// extracted by mini-css-extract-plugin
export default {"dropdown":"ProjectFilterDropdown-styles-module--dropdown--P6ock"};